<template>
    <div class="wrap">
        <listHeader
            :title="postData.clid > 0 ? '编辑课程' : '新增课程'"
            :back="true"></listHeader>

        <div class="wrap-list-content">

            <hro-tab
                scenario="clesson"
                active="info"
                :cbid="postData.cbid"
                :clid="postData.clid"
            ></hro-tab>

            <div class="wrap-form-info">
                <a-row>
                    <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                        <a-form :form="form">

                            <a-form-item
                                label="班级类型"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-select
                                    placeholder="选择班级类型"
                                    v-decorator="['type', {required: true, rules: [{ message: '选择班级类型' }]}]">
                                    <a-select-option v-for="(item, key) in config.type" :key="key" :value="key">
                                        {{ item }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                label="老师"
                                v-bind="formItemLayout"
                            >
                                <a-select v-decorator="['tid', {rules: [{ message: '选择老师' }], initialValue: '0'}]">
                                    <a-select-option value="0">选择老师</a-select-option>
                                    <a-select-option v-for="item in config.teacher" :key="item.tid" :value="item.tid">
                                        {{ item.tname }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                label="教室"
                                v-bind="formItemLayout"
                            >
                                <a-select v-decorator="['cid', {rules: [{ message: '选择教室' }], initialValue: '0'}]">
                                    <a-select-option value="0">选择教室</a-select-option>
                                    <a-select-option v-for="item in config.classroom" :key="item.cid" :value="item.cid">
                                        {{ item.crname }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>

                            <a-form-item
                                label="上课日期"
                                v-bind="formItemLayout"
                            >
                                <a-date-picker
                                    style="width: 100%"
                                    placeholder="请选择上课日期"
                                    v-decorator="['daytime',{rules: [{ required: false, message: '请选择上课日期' }]} ]"
                                />
                            </a-form-item>

                            <a-form-item
                                label="开始时间"
                                v-bind="formItemLayout"
                            >
                                <a-date-picker
                                    :show-time="{ format: 'HH:mm' }"
                                    format="YYYY-MM-DD HH:mm"
                                    style="width: 100%"
                                    placeholder="请选择开始时间"
                                    v-decorator="['starttime',{rules: [{ required: false, message: '请选择开始时间' }]} ]"
                                />
                            </a-form-item>

                            <a-form-item
                                label="结束时间"
                                v-bind="formItemLayout"
                            >
                                <a-date-picker
                                    :show-time="{ format: 'HH:mm' }"
                                    format="YYYY-MM-DD HH:mm"
                                    style="width: 100%"
                                    placeholder="请选择结束时间"
                                    v-decorator="['endtime',{rules: [{ required: false, message: '请选择结束时间' }]} ]"
                                />
                            </a-form-item>

                            <a-form-item
                                v-bind="formBtnLayout"
                            >
                                <a-button type="primary" @click="create">确定</a-button>
                            </a-form-item>
                        </a-form>
                    </a-col>
                </a-row>
            </div>
        </div>
    </div>
</template>

<script>
import listHeader from '@/components/list/listHeader';
import moment from "moment";
import hroTab from '@/components/list/tab';

export default {
    components: {
        listHeader,
        hroTab,
    },
    data() {
        return {
            scenario: 'clessonCreate',
            visible: false, // 是否显示图片src
            formItemLayout: {
                labelCol: {
                    span: 5
                },
                wrapperCol: {
                    span: 19
                },
            },
            formBtnLayout: {
                wrapperCol: {
                    span: 19,
                    offset: 5,
                },
            },
            form: this.$form.createForm(this),
            postData: {
                'clid': '',
            },
            data: {},
            config: {},
            dateFormat: 'YYYY-MM-DD',
            dateFormatTime: 'YYYY-MM-DD HH:mm',
        }
    },
    Watch: {
    },
    created() {
        this.setData();
        this.getData();
    },
    methods: {
        setData() {
            for (let i in this.postData) {
                if (this.$route.query[i] === undefined) continue;
                this.postData[i] = this.$route.query[i];
            }
        },
        getData() {
            // 查询数据
            this.http('/manage/clesson/info', this.postData, (res) => {
                this.data = res.data;
                this.config = res.config;

                if (res.data.clid) {
                    this.$nextTick(() => {
                        this.form.setFieldsValue({
                            type: res.data.type,
                            tid: res.data.tid,
                            cid: res.data.cid,
                            daytime: res.data.daytime != '0' ? moment(res.data.daytime_str, this.dateFormat) : null,
                            starttime: res.data.starttime != '0' ? moment(res.data.starttime_str, this.dateFormatTime) : null,
                            endtime: res.data.endtime != '0' ? moment(res.data.endtime_str, this.dateFormatTime) : null,
                        });
                    });
                }

            }, null, 2);
        },
        create() {
            this.form.validateFields(
                (errors, values) => {
                    if (!errors) {

                        let url = '/manage/clesson/edit';

                        values.clid = this.postData.clid;
                        values.daytime = values.daytime ? values.daytime.format(this.dateFormat) : '';
                        values.starttime = values.starttime ? values.starttime.format(this.dateFormatTime) : '';
                        values.endtime = values.endtime ? values.endtime.format(this.dateFormatTime) : '';

                        this.http(url, values, (res) => {
                            this.toast({content: '操作成功'}, (res) => {
                                if (this.postData.clid == '') {
                                    this.$router.go(-1);
                                } else {
                                    this.getData();
                                }
                            });
                        }, null, 1);
                    }
                }
            );
        },
    },
}
</script>

<style lang="less" src="../../assets/css/add/add.less"></style>
